var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeviceErr = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 4.49998C22.5 7.7616 19.5355 7.49472 16.5 7.49472C13.1863 7.49472 10.5 7.45363 10.5 4.5C10.5 1.54637 13.1863 1.50528 16.5 1.50528C19.8137 1.50528 22.5 1.23837 22.5 4.49998Z",
    stroke: "#E1173C",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7.5C5.5 14.4644 5.5 16.5 8.5 16.5",
    stroke: "#E1173C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 7.5C27.5 14.4644 27.5 16.5 24.5 16.5",
    stroke: "#E1173C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16446 7.24732C3.79749 6.83459 3.83459 6.20251 4.24732 5.83554V5.83554C4.66005 5.46856 5.29213 5.50566 5.65911 5.91839L6.98803 7.41304C7.355 7.82577 7.31791 8.45785 6.90517 8.82482V8.82482C6.49244 9.19179 5.86036 9.1547 5.49339 8.74196L4.16446 7.24732Z",
    fill: "#E1173C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8355 7.24732C29.2025 6.83459 29.1654 6.20251 28.7527 5.83554V5.83554C28.3399 5.46856 27.7079 5.50566 27.3409 5.91839L26.012 7.41304C25.645 7.82577 25.6821 8.45785 26.0948 8.82482V8.82482C26.5076 9.19179 27.1396 9.1547 27.5066 8.74196L28.8355 7.24732Z",
    fill: "#E1173C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 15.4999C24.5 17.8551 20.9183 17.4778 16.5 17.4778C12.0817 17.4778 8.5 17.7363 8.5 15.4999C8.5 13.2635 12.0817 13.5223 16.5 13.5223C20.9183 13.5223 24.5 13.1447 24.5 15.4999Z",
    stroke: "#E1173C",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3498 7.5C12.0049 7.5 8.02129 7.49996 8.54561 10.4335C8.93112 12.5903 10.1078 12.9291 12.72 13.5",
    stroke: "#E1173C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.35 7.5C20.6949 7.5 24.9799 7.49996 24.4556 10.4335C24.0701 12.5903 22.8934 12.9291 20.2812 13.5",
    stroke: "#E1173C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4262 9.5C14.1722 9.5 11.1417 9.49997 11.5344 11.4556C11.8231 12.8935 12.7044 13.1194 14.6606 13.5",
    stroke: "#E1173C",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3146 9.5C19.1618 9.5 21.8135 9.49997 21.4699 11.4556C21.2173 12.8935 20.4462 13.1194 18.7344 13.5",
    stroke: "#E1173C",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7227 17.5H19.2773C21.3133 17.5 22.9675 19.1344 22.9995 21.1628L22.4841 25.1991C22.0971 28.2295 19.5181 30.5 16.4631 30.5C13.3665 30.5 10.7663 28.1689 10.4294 25.0907L10.0003 21.1713C10.0278 19.139 11.6839 17.5 13.7227 17.5Z",
    stroke: "#E1173C",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 33.5C19.5376 33.5 22 32.6046 22 31.5C22 30.3954 19.5376 29.5 16.5 29.5C13.4624 29.5 11 30.3954 11 31.5C11 32.6046 13.4624 33.5 16.5 33.5Z",
    fill: "#E1173C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21 26.0556C21 26.8334 20.999 27.4575 20.929 27.9777C20.8598 28.4909 20.7295 28.8461 20.5112 29.109C20.2958 29.3683 19.9483 29.5935 19.335 29.7532C18.7153 29.9145 17.8578 30 16.6667 30C14.2475 30 13.1618 29.6432 12.6343 29.085C12.3767 28.8124 12.2143 28.4522 12.1188 27.9509C12.0217 27.4412 12 26.8219 12 26.0556C12 24.5579 12.2477 23.3016 12.9008 22.4262C13.5312 21.5811 14.6103 21 16.5 21C18.3897 21 19.4688 21.5811 20.0992 22.4262C20.7523 23.3016 21 24.5579 21 26.0556Z",
    stroke: "#E1173C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeviceErr);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/DeviceErr.1c07d03dd626a9b0b74d97af9eb9e948.svg";